/** Never a bare spinner. A skeleton at least tells you what is about to arrive. */
export function SkeletonEvents({ rows = 3 }: { rows?: number }) {
  return (
    <div className="ev-list" aria-hidden="true">
      <div className="card sk sk-block" style={{ height: 148 }} />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="card sk sk-block" style={{ height: 86 }} />
      ))}
    </div>
  );
}

export function SkeletonGrid({ tiles = 6 }: { tiles?: number }) {
  return (
    <div className="gal-grid" aria-hidden="true">
      {Array.from({ length: tiles }, (_, i) => (
        <div key={i} className="tile">
          <div className="tile-frame sk" style={{ borderRadius: 22 }} />
          <div className="sk" style={{ height: 10, width: '60%', marginLeft: 4 }} />
        </div>
      ))}
    </div>
  );
}
